module.exports = __webpack_public_path__ + "static/media/1840.9f8cbbd0.jpg";